import React from "react"
import { Grid } from "@mui/material"
import { useComputed } from "@preact/signals-react"
import { reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"
import { MULTIPLE_OPTIONS } from "Pages/ReportsAlerts/Reports/@constants"
import ReportMultiModalDateSection from "Pages/ReportsAlerts/Reports/@components/MultipleModal/Content/DateSection"
import ReportMultiModalSiteSection from "Pages/ReportsAlerts/Reports/@components/MultipleModal/Content/SiteSection"
import ReportMultiModalEmailSection from "Pages/ReportsAlerts/Reports/@components/MultipleModal/Content/EmailSection"
import ReportMultiModalFrequencySection from "Pages/ReportsAlerts/Reports/@components/MultipleModal/Content/FrequencySection"
import ReportMultiModalExecutionDatesSection from "Pages/ReportsAlerts/Reports/@components/MultipleModal/Content/ExecutionDatesSection"

export default function ReportListMultipleModalContent() {

	const optionSelected = useComputed(() => reportListMultipleData.value?.key)

	return <Grid container spacing={2}>
		{optionSelected.value === MULTIPLE_OPTIONS.SITES && <Grid item xs={12}>
			<ReportMultiModalSiteSection/>
		</Grid>}
		{optionSelected.value === MULTIPLE_OPTIONS.DATES && <Grid item xs={12}>
			<ReportMultiModalDateSection/>
		</Grid>}
		{optionSelected.value === MULTIPLE_OPTIONS.EMAILS && <Grid item xs={12}>
			<ReportMultiModalEmailSection/>
		</Grid>}
		{optionSelected.value === MULTIPLE_OPTIONS.FREQUENCY && <Grid item xs={12}>
			<ReportMultiModalFrequencySection/>
		</Grid>}
		{optionSelected.value === MULTIPLE_OPTIONS.EXECUTION_DATES && <Grid item xs={12}>
			<ReportMultiModalExecutionDatesSection/>
		</Grid>}
	</Grid>
}